import { QueryString } from "@grandvisionhq/utils";
const useGetQueryParams = () => {
  return typeof window !== "undefined" ? QueryString.parse(window.location.search.substring(1)) : {};
};
export {
  useGetQueryParams
};
//# sourceMappingURL=get-query-params.js.map
